export default __webpack_public_path__ + "static/media/laundry2-before-2048w.d2d86f6c.png";